import { render, staticRenderFns } from "./AddTestForm.vue?vue&type=template&id=44efc7e4&scoped=true"
import script from "./AddTestForm.vue?vue&type=script&lang=js"
export * from "./AddTestForm.vue?vue&type=script&lang=js"
import style0 from "./AddTestForm.vue?vue&type=style&index=0&id=44efc7e4&prod&lang=scss"
import style1 from "./AddTestForm.vue?vue&type=style&index=1&id=44efc7e4&prod&lang=scss&scoped=true"
import style2 from "./AddTestForm.vue?vue&type=style&index=2&id=44efc7e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44efc7e4",
  null
  
)

export default component.exports